/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Bootstrap_SlowInputs */



/**
* | output |
* | --- |
* | "This is taking longer than usual…" |
*
* @param {Auth_Bootstrap_SlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_bootstrap_slow = /** @type {((inputs?: Auth_Bootstrap_SlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Bootstrap_SlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das dauert länger als gewöhnlich …")
	return /** @type {LocalizedString} */ ("This is taking longer than usual…")
});